import ModalCompanyUsersModule from './containers/modalCompanyUsersModule'

export {default as ModalCompanyUsersModuleLayout} from './components/modalCompanyUsersModuleLayout'

export default ModalCompanyUsersModule
